<template>
  <div>
    <keep-alive :include="['manager', 'do']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "layout",
};
</script>
